import { ValidationRule } from 'vuelidate/lib/validators';

export const checked = ((value: boolean): boolean => !!value) as ValidationRule;
